export const quiz = [
  {
    question:
      "Variables declared with the let keyword have what type of scope?",
    choices: ["function scope", "block scope", "inline scope", "global scope"],
    correctAnswer: "block scope",
  },
  {
    question:
      "Which attribute must have a unique value each time it is used in an HTML document?",
    choices: ["title", "class", "style", "id"],
    correctAnswer: "id",
  },
  {
    question: "What does the === comparison operator do?",
    choices: [
      "It sets one variable equal to another in both value and type",
      "It tests for equality of type only",
      "It tests for equality of value only",
      "It tests for equality of value and type",
    ],
    correctAnswer: "It tests for equality of value and type",
  },
];
